__turbopack_context__.v({
  "AuthorSlider": "zCQfma_AuthorSlider",
});
